/**
 * @file paddle 教程 ipynb 的教程
 * @author FengGuang(fengguang01@baidu.com)
 */
import baseRequest2 from '../baseApi2';
import request from 'superagent';

export const fetchGetTutorialsLessonGroup = (groupId: number | string) =>
    baseRequest2(
        request
            .get('/studio/edu/group/lesson/list/platform')
            .query({
                groupId
            })
    );

export const fetchGetTutorialsLessonList = (lessonId: number | string) =>
    baseRequest2(
        request
            .get('/studio/edu/group/lesson/project/list/platform')
            .query({
                lessonId
            })
    );

interface IProjectContentParams {
    projectId: number | string;
    versionId?: 0;
}

export const fetchGetProjectContent = (params: IProjectContentParams) =>
    baseRequest2(
        request
            .post('/studio/ipynb/content/platform')
            .type('form')
            .send({
                versionId: 0,
                ...params
            })
    );

export const getCacheData = (params: {version: string, tab: number}) =>
    baseRequest2(
        request
            .post('/studio/getTutorialsMenu')
            .type('form')
            .send({
                ...params
            })
    );


export const getProjectMap = () =>
    baseRequest2(
        request
            .post('/studio/getAllProject')
            .type('form')
    );
